import { css } from 'linaria';

export const boosterButtonStyles = css`
  width: 100%;
  margin-bottom: var(--space-200);
`;
